import { Navigation } from './Navigation/Navigation';
import { SalonHeading } from './SalonHeading';

import s from './ClassicHeader.module.css';

export const ClassicHeader = () => {
  return (
    <header className={s.header}>
      <Navigation />
      <SalonHeading className={s.salonHeading} />
    </header>
  );
};
